<div class="bi-wrap">

  <!-- ===== step rail ===== -->
  <ol class="bi-steps">
    <li [class.on]="step===0" [class.done]="step>0"><b>1</b> Izbira modela</li>
    <li [class.on]="step===1" [class.done]="step>1"><b>2</b> Datoteka</li>
    <li [class.on]="step===2" [class.done]="step>2"><b>3</b> Preslikava stolpcev</li>
    <li [class.on]="step===3" [class.done]="step>3"><b>4</b> Predogled in preverjanje</li>
    <li [class.on]="step===4"><b>5</b> Uvoz</li>
  </ol>

  <div class="bi-msg bad" *ngIf="error">{{ error }}</div>
  <div class="bi-msg" *ngIf="busy">Delam …</div>

  <!-- ================================================= STEP 0 -->
  <div class="bi-panel" *ngIf="step===0">
    <h2>Izberite model za uvoz</h2>
    <p class="bi-sub">
      Na voljo so samo modeli, do katerih imate pravice.
      <span class="bi-pill" *ngIf="!modelsLoading">{{ modelMatchCount }} od {{ modelChoices.length }}</span>
    </p>

    <div class="bi-mfilter">
      <input id="bi-model-search" type="text" placeholder="Iskanje po imenu …"
             [(ngModel)]="modelSearch" (ngModelChange)="onModelSearchChanged()">
      <div class="bi-seg">
        <button type="button" [class.on]="modelTypeFilter==='document'"
                (click)="setModelTypeFilter('document')">Dokumenti</button>
        <button type="button" [class.on]="modelTypeFilter==='registry'"
                (click)="setModelTypeFilter('registry')">Šifranti</button>
        <button type="button" [class.on]="modelTypeFilter===''"
                (click)="setModelTypeFilter('')">Vsi</button>
      </div>
    </div>

    <div class="bi-msg" *ngIf="modelsLoading">Berem seznam modelov …</div>
    <div class="bi-note" *ngIf="!modelsLoading && !modelMatchCount">
      Noben model ne ustreza iskanju.
    </div>

    <div class="bi-mgroup" *ngFor="let g of modelGroups">
      <div class="bi-mgroup-h">{{ g.section }}</div>
      <div class="bi-mgrid">
        <button type="button" class="bi-mcard" *ngFor="let c of g.items"
                [attr.data-model]="c.fullName"
                [class.on]="c.fullName===modelFullName"
                (click)="chooseModel(c)">
          <b>{{ c.label }}</b>
          <span class="ty" [class.reg]="c.type==='registry'">
            {{ c.type === 'registry' ? 'šifrant' : 'dokument' }}
          </span>
          <span class="mod" *ngIf="c.moduleName">{{ c.moduleName }}</span>
          <span class="fq">{{ c.name }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- ================================================= STEP 1 -->
  <div class="bi-panel" *ngIf="step===1">
    <h2>Izberite Excel datoteko</h2>
    <p class="bi-sub">
      Cilj uvoza: <b id="bi-target">{{ modelLabel || modelFullName }}</b>
      <button type="button" class="bi-link" id="bi-change-model" (click)="changeModel()">zamenjaj model</button>
      <span class="bi-pill" *ngIf="columnsResponse">{{ columns.length }} stolpcev · postavitev
        „{{ columnsResponse.AppliedLayout || 'polna' }}“</span>
    </p>

    <div class="bi-template">
      <button id="bi-template" class="bi-btn ghost" [disabled]="downloadingTemplate || busy" (click)="downloadTemplate()">
        <span class="xi">⬇</span>{{ downloadingTemplate ? 'Pripravljam …' : 'Prenesi predlogo' }}
      </button>
      <span class="bi-template-help">
        Predloga vsebuje vse podprte stolpce in <b>dve vzorčni vrstici</b> s pravimi vrednostmi iz te
        baze. Vzorčni vrstici sta samo primer — <b>zamenjajte ju s svojimi podatki</b>, preden datoteko
        naložite nazaj.
      </span>
    </div>

    <input id="bi-file" type="file" accept=".xlsx,.xls" (change)="onFileSelected($event)">
    <div class="bi-file" *ngIf="fileName"><span class="xi">📊</span>{{ fileName }}</div>

    <div class="bi-cols" *ngIf="columns.length">
      <span class="bi-lbl">Podprti stolpci</span>
      <span class="bi-chip" *ngFor="let c of columns">
        <b>{{ c.Title || c.Binding }}</b>
        <span class="ty">{{ kindLabel(c.Kind) }}</span>
        <span class="ty doc" *ngIf="c.IsDocumentReference" title="Dokumentna referenca — brez šifrantskega spustnega seznama">DOK</span>
      </span>
    </div>
    <div class="bi-note" *ngIf="columnsResponse?.MissingRequestedBindings?.length">
      Ni na voljo v tej fazi: {{ columnsResponse.MissingRequestedBindings.join(', ') }}
      — vezave tipa <i>ena-proti-mnogo</i>, ki jih generator stolpcev še ne zna izraziti.
    </div>

    <div class="bi-actions">
      <button id="bi-parse" class="bi-btn primary" [disabled]="!file || busy" (click)="parseFile()">Preberi datoteko →</button>
    </div>
  </div>

  <!-- ================================================= STEP 2 -->
  <div class="bi-panel" *ngIf="step===2 && parsed">
    <h2>Preslikava stolpcev</h2>
    <p class="bi-sub">
      {{ parsed.RowCount }} vrstic · {{ mappedCount }} od {{ mappedHeaders.length }} stolpcev preslikanih.
      Predlog je pripravil strežnik; spodaj ga lahko popravite.
    </p>

    <div class="bi-msg bad" *ngIf="duplicateHeaderNames.length" id="bi-dupe-header-warning">
      <b>Podvojena glava stolpca:</b>
      <span *ngFor="let h of duplicateHeaderNames; let last = last">
        Glava "{{ h }}" se pojavi večkrat — upoštevan bo samo prvi stolpec, ostali bodo prezrti.<ng-container *ngIf="!last"> </ng-container>
      </span>
    </div>

    <table class="bi-map">
      <thead><tr><th>Stolpec v datoteki</th><th></th><th>Polje v Galisu</th><th>Tip</th></tr></thead>
      <tbody>
        <tr *ngFor="let h of mappedHeaders; let i = index" [class.dupe]="isDuplicateBinding(h) || isDuplicateHeaderName(h)">
          <td><b>{{ h }}</b></td>
          <td class="arrow">→</td>
          <td>
            <select class="bi-ctl" [attr.id]="'bi-map-' + i" [(ngModel)]="mapping[h]" [ngModelOptions]="{standalone:true}">
              <option value="">— ne uvozi —</option>
              <option *ngFor="let c of columns" [value]="c.Binding">{{ c.Title || c.Binding }}</option>
            </select>
            <div class="bi-emsg" *ngIf="isDuplicateBinding(h)">Isto polje je izbrano večkrat — strežnik upošteva samo prvi stolpec.</div>
            <div class="bi-emsg" *ngIf="isDuplicateHeaderName(h)">Glava stolpca se v datoteki pojavi večkrat — ostali stolpci s to glavo bodo prezrti.</div>
          </td>
          <td>
            <span class="ty" *ngIf="mapping[h]">{{ kindLabelForBinding(mapping[h]) }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="bi-note" *ngIf="parsed.IgnoredHeaders?.length">
      <b>Neuporabljeni stolpci ({{ parsed.IgnoredHeaders.length }}):</b>
      <span class="bi-chip un" *ngFor="let h of parsed.IgnoredHeaders">{{ h }} → ni preslikano</span>
    </div>

    <div class="bi-actions">
      <button class="bi-btn" (click)="back(1)">← Nazaj</button>
      <button id="bi-preview" class="bi-btn primary" [disabled]="busy" (click)="applyMappingAndPreview()">Naprej na predogled →</button>
    </div>
  </div>

  <!-- ================================================= STEP 3 -->
  <div *ngIf="step===3">

    <div class="bi-ctxbar">
      <div class="bi-file"><span class="xi">📊</span>{{ fileName }}</div>
      <div class="seg"><button class="on">Dodajanje novih</button><button disabled title="Faza dve">Skupinsko urejanje</button></div>
      <!-- Every pill is WHOLE-SHEET. None of them is page-local. -->
      <div class="pills">
        <span class="bi-pill p-blue" id="bi-cnt-sel">{{ selectedCount }} izbranih za uvoz</span>
        <span class="bi-pill p-green" id="bi-cnt-valid">{{ validRowCount }} brez napak</span>
        <span class="bi-pill p-amber" id="bi-cnt-warn">{{ warningCount }} opozoril</span>
        <span class="bi-pill p-red" id="bi-cnt-err">{{ errorRowCount }} vrstic z napako</span>
      </div>
    </div>


    <div class="bi-tablewrap">
      <div class="bi-tablehead">
        <span>Vrstic v datoteki: <span class="res">{{ rows.length }}</span></span>
        <span class="sel">Izbranih za uvoz: <span class="res" id="bi-head-sel">{{ selectedCount }}</span>
          od {{ validRowCount }} možnih</span>

        <label class="bi-toggle" title="Pokaži samo vrstice z napako ali opozorilom">
          <input id="bi-errors-only" type="checkbox" [checked]="errorsOnly"
                 (change)="setErrorsOnly($any($event).target.checked)">
          <span>Samo vrstice s težavo</span>
        </label>

        <label class="bi-toggle" title="Privzeto so prikazani samo stolpci iz naložene datoteke. Obkljukajte, da dodate še ostala polja in jih izpolnite tukaj.">
          <input id="bi-show-all-cols" type="checkbox" [checked]="showAllColumns"
                 (change)="setShowAllColumns($any($event).target.checked)">
          <span>Prikaži vse stolpce</span>
        </label>

        <span class="bi-colcount" id="bi-colcount">Stolpcev: <span class="res">{{ gridColumns.length }}</span>
          od {{ columns.length }}</span>

        <span class="grow"></span>

        <label class="bi-pagesize">Vrstic na stran
          <select class="bi-ctl" id="bi-pagesize" [value]="pageSize"
                  (change)="onPageSizeChanged($any($event).target.value)">
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="250">250</option>
          </select>
        </label>
      </div>

      <div class="bi-note prose" *ngIf="!showAllColumns && hiddenColumnCount">
        <ng-container>Prikazani so stolpci iz naložene datoteke<ng-container *ngIf="revealedByMessageCount"> in {{ revealedByMessageCount }} stolpcev s težavo</ng-container>. Še <b>{{ hiddenColumnCount }} polj</b> lahko izpolnite tukaj — obkljukajte <b>Prikaži vse stolpce</b>.</ng-container>
      </div>
      <div class="bi-note prose" *ngIf="showAllColumns">
        <ng-container>Prikazana so <b>vsa polja</b>, ki jih je mogoče uvoziti. Kar vpišete v prazen stolpec, se shrani skupaj z vrstico.</ng-container>
      </div>

      <div class="bi-note" *ngIf="errorsOnly">
        Filter je vklopljen — prikazane so samo vrstice s težavo. Števci zgoraj in gumb za uvoz
        veljajo za <b>celotno datoteko</b>, ne za ta izbor.
      </div>

      <div class="bi-scroll">
        <table class="bi-tbl">
          <thead>
            <tr>
              <th class="num sel">
                <input id="bi-select-all" type="checkbox"
                       [checked]="allSelectableSelected"
                       [disabled]="!validation || selectableRowCount===0"
                       (change)="toggleAll($any($event).target.checked)"
                       title="Izberi / odznači vse vrstice brez napake v CELOTNI datoteki">
              </th>
              <th class="num">#</th>
              <th class="num"></th>
              <th *ngFor="let c of gridColumns" [class.req]="c.Required">
                {{ c.Title || c.Binding }}<span class="ty">{{ kindLabel(c.Kind) }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Iterating ORIGINAL indices, so `ri` is the row's real position in the sheet on
                 every page and under every filter. The row number shown is ri+1, always. -->
            <tr *ngFor="let ri of visibleIndices" [class.rowerr]="rowState(ri)==='err'"
                [class.rowoff]="validation && !isSelected(ri)">
              <td class="num sel">
                <input type="checkbox" [attr.data-sel]="ri"
                       [checked]="isSelected(ri)"
                       [disabled]="!isSelectable(ri)"
                       [title]="isSelectable(ri) ? 'Uvozi to vrstico' : 'Vrstica ima napako in je ni mogoče uvoziti'"
                       (change)="toggleRow(ri, $any($event).target.checked)">
              </td>
              <td class="rownum">{{ ri + 1 }}</td>
              <td class="num"><span class="rstat" [ngClass]="'s-' + rowState(ri)"></span></td>

              <td *ngFor="let c of gridColumns" [attr.data-cell]="ri + '|' + c.Binding">

                <!-- Checkbox -->
                <label class="bi-ctl chk" *ngIf="c.Kind===4" [ngClass]="cellState(ri, c.Binding)">
                  <input type="checkbox"
                         [checked]="rows[ri][c.Binding]==='true' || rows[ri][c.Binding]==='1' || rows[ri][c.Binding]==='da'"
                         (change)="onCheckToggle(rows[ri], c.Binding, $any($event).target.checked)">
                  <span>{{ (rows[ri][c.Binding]==='true' || rows[ri][c.Binding]==='1' || rows[ri][c.Binding]==='da') ? 'da' : 'ne' }}</span>
                </label>

                <!-- Registry with a real dropdown (NOT a document reference) -->
                <ng-container *ngIf="c.Kind===5 && hasDropdown(c)">
                  <select class="bi-ctl dd" [ngClass]="cellState(ri, c.Binding)"
                          [(ngModel)]="rows[ri][c.Binding]" [ngModelOptions]="{standalone:true}" (ngModelChange)="onCellEdited()">
                    <option value="">—</option>
                    <option *ngIf="rows[ri][c.Binding] && optionsFor(c).indexOf(rows[ri][c.Binding]) < 0" [value]="rows[ri][c.Binding]">
                      {{ rows[ri][c.Binding] }} (ni v šifrantu)
                    </option>
                    <option *ngFor="let o of optionsFor(c)" [value]="o">{{ o }}</option>
                  </select>
                </ng-container>

                <!-- Document reference: plain text, resolved by NAME on the server -->
                <input *ngIf="c.Kind===5 && !hasDropdown(c)" class="bi-ctl"
                       [ngClass]="cellState(ri, c.Binding)" type="text"
                       [(ngModel)]="rows[ri][c.Binding]" [ngModelOptions]="{standalone:true}" (ngModelChange)="onCellEdited()"
                       placeholder="ime lokacije">

                <!-- Date -->
                <input *ngIf="c.Kind===3" class="bi-ctl date" [ngClass]="cellState(ri, c.Binding)" type="text"
                       [(ngModel)]="rows[ri][c.Binding]" [ngModelOptions]="{standalone:true}" (ngModelChange)="onCellEdited()"
                       placeholder="dd.mm.llll">

                <!-- Number / Decimal -->
                <input *ngIf="c.Kind===1 || c.Kind===2" class="bi-ctl numin" [ngClass]="cellState(ri, c.Binding)" type="text"
                       [(ngModel)]="rows[ri][c.Binding]" [ngModelOptions]="{standalone:true}" (ngModelChange)="onCellEdited()">

                <!-- Text -->
                <input *ngIf="c.Kind===0" class="bi-ctl"
                       [class.inv]="c.Binding==='InvNumber'"
                       [ngClass]="cellState(ri, c.Binding)" type="text"
                       [(ngModel)]="rows[ri][c.Binding]" [ngModelOptions]="{standalone:true}" (ngModelChange)="onCellEdited()">

                <!-- Kind 6 (Collection). The cell is still one delimited string in `rows` - the
                     pills are a view over it and every add/remove rewrites the string. The pill row
                     IS the error display for this cell: a token the server could not bind renders
                     red and clicking it opens the picker. -->
                <div *ngIf="c.Kind===6" class="bi-pills" [ngClass]="cellState(ri, c.Binding)">
                  <span *ngFor="let p of pillsFor(ri, c); let pi = index"
                        class="bi-tok" [ngClass]="'t-' + p.s"
                        [title]="p.s === 'bad' ? pillMessage(ri, c, p.t) : p.t">
                    <span class="bi-tok-t" (click)="openPicker(ri, c, pi)">{{ p.t }}</span>
                    <button type="button" class="bi-tok-x" (click)="removeToken(ri, c, pi)"
                            [attr.aria-label]="'Odstrani ' + p.t">&times;</button>
                  </span>
                  <button type="button" class="bi-tok-add" (click)="openPicker(ri, c, -1)"
                          [title]="'Dodaj: ' + (c.ChildTitle || c.Title)">+</button>
                </div>

                <!-- Picker, inline under the cell rather than an overlay: the list page's sticky
                     header intercepts absolutely-positioned popups. -->
                <div class="bi-pick" *ngIf="isPickerOpen(ri, c.Binding)">
                  <input class="bi-ctl" type="text" autocomplete="off"
                         [(ngModel)]="picker.text" [ngModelOptions]="{standalone:true}"
                         (keyup.enter)="applyPicker()" (keyup.escape)="closePicker()"
                         [placeholder]="c.ChildTitle || c.Title">
                  <div class="bi-pick-note" *ngIf="picker.note">{{ picker.note }}</div>
                  <div class="bi-pick-note" *ngIf="pickerLoading">Nalagam sifrant ...</div>
                  <div class="bi-pick-note" *ngIf="pickerFreeTextOnly">
                    Sifrant ni na voljo za ta stolpec - vnesite vrednost rocno.
                  </div>
                  <div class="bi-pick-list" *ngIf="!pickerLoading && !pickerFreeTextOnly">
                    <button type="button" class="bi-pick-o" *ngFor="let o of pickerSuggestions"
                            (click)="chooseSuggestion(o)">{{ o }}</button>
                    <div class="bi-pick-note" *ngIf="pickerTruncated">
                      Prikazanih prvih 30 - natipkajte vec crk.
                    </div>
                    <div class="bi-pick-note" *ngIf="!pickerSuggestions.length">
                      Ni zadetkov v seznamu. Vrednost lahko vseeno vnesete - preverjanje jo bo
                      poiskalo v celotnem sifrantu.
                    </div>
                  </div>
                  <div class="bi-pick-act">
                    <button type="button" class="bi-btn sm" (click)="applyPicker()">Potrdi</button>
                    <button type="button" class="bi-btn sm ghost" (click)="closePicker()">Preklici</button>
                  </div>
                </div>

                <div class="bi-resolved" *ngIf="c.Kind===5 && resolvedId(ri, c.Binding) !== null">
                  🔗 vezano na id {{ resolvedId(ri, c.Binding) }}
                </div>

                <div class="bi-emsg" *ngFor="let m of messagesFor(ri, c.Binding)" [class.w]="!m.IsError">
                  {{ m.IsError ? '⚠' : '↪' }} {{ m.Message }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="bi-gridfoot">
        <div class="summ">
          <span class="ok">Izbrano za uvoz: <b id="bi-foot-sel">{{ selectedCount }}</b></span>
          <span class="er">Vrstic z napako (ni mogoče izbrati): <b>{{ errorRowCount }}</b></span>
          <span>Cilj: <b>Inventarna knjiga</b></span>
          <span class="warnnote" *ngIf="!validation">Po urejanju je potrebno ponovno preverjanje.</span>
        </div>

        <div class="pagenav" *ngIf="filteredIndices.length">
          <button class="bi-btn sm" id="bi-prev" [disabled]="pageIndex===0" (click)="prevPage()">←</button>
          <span class="pgtxt" id="bi-pagetxt">
            {{ pageFrom }}–{{ pageTo }} od {{ filteredIndices.length }}
            <span class="dim">(stran {{ pageIndex + 1 }} / {{ pageCount }})</span>
          </span>
          <button class="bi-btn sm" id="bi-next" [disabled]="pageIndex >= pageCount - 1" (click)="nextPage()">→</button>
        </div>
        <div class="pagenav" *ngIf="!filteredIndices.length">
          <span class="pgtxt dim">Ni vrstic za prikaz pri tem filtru.</span>
        </div>

        <div class="pager">
          <button class="bi-btn" (click)="back(2)">← Preslikava</button>
          <button id="bi-validate" class="bi-btn" [disabled]="busy" (click)="validate()">Preveri</button>
          <button id="bi-commit" class="bi-btn primary" [disabled]="!canCommit" (click)="commit()">
            Uvozi {{ selectedCount }} izbranih →
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ================================================= STEP 4 -->
  <div class="bi-panel" *ngIf="step===4 && commitResult">
    <h2>Uvoz zaključen</h2>
    <div class="bi-msg" [class.good]="commitResult.Failed===0" [class.bad]="commitResult.Failed>0">
      <span id="bi-created">Ustvarjenih: <b>{{ commitResult.Created }}</b></span> ·
      <span id="bi-failed">Neuspešnih: <b>{{ commitResult.Failed }}</b></span>
    </div>

    <div class="bi-scroll short">
      <table class="bi-tbl">
        <thead><tr><th class="num">Vrstica</th><th>Status</th><th>Id zapisa</th><th>Napaka</th></tr></thead>
        <tbody>
          <tr *ngFor="let r of commitResult.Results" [class.rowerr]="!r.Success">
            <td class="rownum">{{ originalRowNumber(r.RowIndex) }}</td>
            <td>{{ r.Success ? '✔ uvoženo' : '✖ napaka' }}</td>
            <td>{{ r.CreatedId }}</td>
            <td class="errtxt">{{ translateCommitError(r.Error) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bi-actions">
      <button class="bi-btn primary" (click)="restart()">Nov uvoz</button>
    </div>
  </div>

</div>
